import React from "react";
import Tooltip from "@mui/material/Tooltip";

export const getStudentDisplayName = (student) => {
  if (student?.pseudonymisedAt) return "Inactive Student";
  return (
    student?.identifier ||
    [student?.firstName, student?.lastName].filter(Boolean).join(" ") ||
    "Unknown Student"
  );
};

export const StudentName = ({ student }) => {
  const name = getStudentDisplayName(student);
  if (!student?.pseudonymisedAt) return name;
  return (
    <Tooltip
      describeChild
      title="This student is no longer active on Fruitify as they are outside of the year group licence."
    >
      <span tabIndex={0}>{name}</span>
    </Tooltip>
  );
};
